import { Col, Row } from 'antd';
import { AxiosError } from 'axios';
import ButtonComponent from 'components/atoms/ButtonComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import TranslateText from 'components/hoc/TranslateText';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import bankidApi from 'services/bankid/bankid';
import { IZadostData } from 'services/bankid/zadost';

interface IPLZAPL {
    zadostData?: IZadostData;
}

const PLZAPL: React.FC<IPLZAPL> = props => {
    const history = useHistory();
    const { zadostData } = props;
    const [errStatus, setErrStatus] = useState<number>();

    const routeChange = () => {
        let path = zadostData?.idzadosti
            ? '/nezarazeny-ucet/bankid/' + zadostData.idzadosti
            : '/nezarazeny-ucet/bankid';
        history.push(path);
    };

    const onClick = () => {
        zadostData?.idzadosti
            ? bankidApi('RC', zadostData?.idzadosti)
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  .then((resp: any) => {
                      window.open(resp.urlbankid, '_parent'); // Redirectne uzivatele na stranky Bank ID
                  })
                  .catch((err: AxiosError) => {
                      setErrStatus(err.response?.status);
                  })
            : setErrStatus(500);
    };

    return (
        <>
            {errStatus ? (
                <Col span={24}>
                    <Row>
                        {errStatus === 400 ? (
                            <Title text="RESPONSE_ERROR_400" level={3} />
                        ) : errStatus === 401 ? (
                            <Title text="RESPONSE_ERROR_401" level={3} />
                        ) : errStatus === 404 ? (
                            <Title text="RESPONSE_ERROR_404" level={3} />
                        ) : errStatus === 500 ? (
                            <Title text="RESPONSE_ERROR_500" level={3} />
                        ) : errStatus ? (
                            <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                        ) : null}
                    </Row>

                    <Row className="statement-buttons-row">
                        <ButtonComponent buttontext="PREJIT_ZPET_NA_PRIHLASENI" onClick={routeChange} />
                    </Row>
                </Col>
            ) : (
                <>
                    <Row>
                        <h1>
                            <TranslateText>STAV_PLZAPL_NADPIS</TranslateText>
                        </h1>
                    </Row>
                    <Row>
                        <Paragraph text="STAV_PLZAPL" />
                    </Row>

                    <Row className="statement-buttons-row">
                        <ButtonComponent buttontext="PRIHLASIT_SE_PPRES_BANKID" onClick={onClick} />
                    </Row>
                </>
            )}
        </>
    );
};

export default PLZAPL;
